var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var validateForm = function (formFields) {
    var fields = [];
    formFields === null || formFields === void 0 ? void 0 : formFields.forEach(function (field) {
        var _a;
        var error = '';
        (_a = field.validators) === null || _a === void 0 ? void 0 : _a.forEach(function (validator) {
            error = error || validator(field.value, formFields);
        });
        fields.push(__assign(__assign({}, field), { error: error }));
    });
    return fields;
};
export var isFormValid = function (formFields) {
    var valid = true;
    formFields === null || formFields === void 0 ? void 0 : formFields.forEach(function (field) {
        valid = valid && !field.error;
    });
    return valid;
};
export var noValueValidator = function (value) {
    return !value ? 'no_value' : '';
};
export var emailValidator = function (email) {
    if (!email)
        return 'invalid_email';
    var regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return !regex.test(email) ? 'invalid_email' : '';
};
export var lengthValidator = function (length) {
    return function (value) {
        return !value || value.length < length ? 'too_short' : '';
    };
};
export var phoneNumberValidator = function (phoneNumber) {
    if (!phoneNumber)
        return 'invalid_phone_number';
    var regex = /^\+?[0-9\s]{5,20}$/;
    return !regex.test(phoneNumber) ? 'invalid_phone_number' : '';
};
